import { SerializableObject } from '../../common-react/core';

export class ShipmentParcelUnlockCodes extends SerializableObject {
  qrCodeData: string;
  pin: string;
  briefLocationDescription: string;
  phone: string;
  barCodeData: string;
}
